var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKlevuOnboardingLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1173 58.1733C21.552 59.041 21.7404 60.2806 22.6197 60.9004C23.5618 61.5202 24.7552 61.2722 25.3832 60.4045L40.0174 39.5179L54.5888 60.4045C55.2168 61.2722 56.473 61.5202 57.3523 60.9004C58.2316 60.2806 58.4828 59.103 57.8548 58.1733L41.6504 34.9315L40.0174 32.5764L38.3844 34.9315L22.1173 58.1733Z",
    fill: "#97C73E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8907 37.5347C26.3254 38.4024 26.5138 39.642 27.3932 40.2617C28.2725 40.8815 29.5286 40.6336 30.1567 39.7659L40.0175 25.6969L49.8154 39.7039C50.4435 40.6956 51.7625 40.8815 52.6418 40.2617C53.5211 39.642 53.7095 38.4024 53.0814 37.5347L41.6505 21.1105L40.0175 18.7553L38.3845 21.1105L26.8907 37.5347Z",
    fill: "#97C73E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlevuOnboardingLogo);
export default __webpack_public_path__ + "static/media/klevu-onboarding-logo.a6863d62510748ca70d800d91c4ffcef.svg";
export { ForwardRef as ReactComponent };